<template>
    <div class="first_banner">
         <Carousel :autoplay-speed="4000" autoplay>
             <!-- <CarouselItem>
                 <div class="banner4" @click="onVip">
                 </div>
             </CarouselItem> -->
            <CarouselItem v-for="(item,index) in bannerData" :key="index">
                <div class="banner2" :style="{background: 'url('+ item.banner +') no-repeat' }"></div>

            </CarouselItem>
            <!-- <CarouselItem>
               <div class="banner1">
                   <div class="banner1-content">
                       <p class="p-50"><span class="line"></span>开通会员</p>
                       <p class="p-80">尊享全流程<span style="font-weight:bold;margin-left:8px;">版权服务</span></p>
                       <div>
                           <button class="jump_link" @click="govipPersonal">开通个人VIP</button>
                           <button class="jump_link jump_link_margin" @click="govipEnterprise">开通企业VIP</button>
                       </div>
                   </div>
               </div>
            </CarouselItem>           -->
        </Carousel>
       
    </div>
</template>

<script>
import { userInfo,getAllBanner} from "@/api/index";
import Cookies from "js-cookie";
    export default {
        name:'first_banner',
        data(){
            return{
                bannerData: []
            }
        },
        mounted() {
            getAllBanner().then( res => {
                this.bannerData = res.result
            })
        },
        methods:{
            govipPersonal(){
                window.open('/vipPersonal','_blank')
            },
            govipEnterprise(){
                window.open('/vipEnterprise','_blank')
            },
            onVip() {
                let _this = this
                userInfo().then(res=>{
                    console.log("获取用户状态返回值 ：：：：",res);
                    // debugger

                    if(res.code=="200"){
                        let uInfo = res.result;
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        _this.setStore("userInfo", uInfo );
                        if(uInfo ==''){
                            toast('请登录后再操作')
                            return false;
                        }
                        if(uInfo.realNameStatus != 'complete_real_name'){
                            toast('请实名认证后再操作',function(){
                                _this.$router.push({
                                    path:'/authentication'
                                })
                            })
                            return  false
                        }
                        if(uInfo.accountType=='enterprise'){
                            window.open('/vipEnterprise','_blank')
                            return false;
                        } else {
                            window.open('/vipPersonal','_blank')
                             return false;
                        }
                    }else{
                        toast(res.message);
                    }
                });
            }
        }
    }
</script>

<style scoped lang="less">
.first_banner{   
    overflow: hidden;
    /*height: 650px;!*calc(100vh - 80px)*!*/
    height: 540px;
    min-width: 1334px;
    /*background: #000106;*/
    /*.banner1{*/
    /*    height: 650px;*/
    /*    width:100%;*/
    /*    min-width: 1334px;*/
    /*    background: url(../../img/banner1.png) no-repeat;*/
    /*    background-size:100% 100%;*/
    /*    background-position: center;*/
    /*    display: flex;*/
    /*    justify-content: flex-start;*/
    /*    align-items: center;*/
    /*    .banner1-content{*/
    /*        width:1334px;*/
    /*        margin: 0 auto;*/
    /*        .p-50{*/
    /*            font-size:50px;*/
    /*            font-weight:bold;*/
    /*            color:rgba(255,255,255,1);*/
    /*            letter-spacing:3px;*/
    /*            .line{*/
    /*                display: inline-block;*/
    /*                width:70px;*/
    /*                height:1px;*/
    /*                background: #fff;*/
    /*                vertical-align: middle;*/
    /*                margin-right:16px;*/
    /*            }*/
    /*        }*/
    /*        .p-80{*/
    /*            font-size:80px;*/
    /*            font-weight:200;*/
    /*            color:rgba(216,216,216,1);*/
    /*            line-height:120px;*/
    /*            letter-spacing:5px;*/
    /*            margin:12px 0 73px;*/
    /*        }*/
    /*        .jump_link{*/
    /*            display: inline-block;*/
    /*            width:192px;*/
    /*            height:48px;*/
    /*            background:rgba(255,255,255,1);*/
    /*            border:1px solid rgba(219,222,229,1);*/
    /*            font-size:16px;*/
    /*            font-weight:400;*/
    /*            text-align: center;*/
    /*            color:rgba(18,18,16,1);*/
    /*            line-height:48px;*/
    /*            cursor: pointer;*/
    /*            outline: none;*/
    /*        }*/
    /*        .jump_link_margin{*/
    /*            color:rgba(255,255,255,1);*/
    /*            margin-left:20px;*/
    /*            background:transparent;*/
    /*        }*/
    /*    }*/
    /*}*/
    .banner2{
        height: 540px;
        width:100%;
        min-width: 1334px;
        background: url(../../img/banner5@2x.png) no-repeat;
        background-size: auto 100% !important;
        background-position: center !important;
        /*img{*/
        /*    width: 100%;*/
        /*    height: 540px;*/
        /*}*/

    }
    .banner3{
        height: 650px;
        width:100%;
        min-width: 1334px;
        background: url(../../img/banner3.png) no-repeat;
        background-size:cover;
        background-position: center;
    }
    .banner4{
        height: 650px;
        width:100%;
        min-width: 1334px;
        background: url(../../img/vipbg@2x.png) no-repeat;
        background-size:cover;
        background-position: center;
        cursor: pointer;
    }
    /deep/ .ivu-carousel-dots li button{
        background: #fff;
    }
}
</style>